import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TableCell } from '@nagel-types';
import { toCellText } from '../../table-cell-value.utils';

@Component({
    selector: 'app-text-cell',
    templateUrl: './text-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextCellComponent {
    cell = input.required<TableCell>();

    readonly text = computed(() => toCellText(this.cell().value));
    readonly maxWidth = computed(() => this.cell().options?.maxWidth);
    readonly tooltip = computed(() => {
        const { value, options } = this.cell();
        const tooltipMap = options?.tooltipMap;

        if (!tooltipMap) {
            return null;
        }

        const values = Array.isArray(value) ? value : String(value ?? '').split(',');
        const descriptions = values
            .map((item) => tooltipMap[String(item).trim()])
            .filter(Boolean);

        return descriptions.length ? descriptions.join('\n') : null;
    });
}
